<template>
  <app-header-base :light="showLightHeader">
    <div class="h-100 d-flex ai-center">
      <div class="x-header-link-container m-l-auto">
        <client-only>
          <div
              v-if="isLoggedIn"
              class="x-header-link x-header-link--disabled"
              selenium="username-link">
            Hi, {{ firstName }}
          </div>
        </client-only>
      </div>
    </div>
  </app-header-base>
</template>

<script>
import { mapGetters } from 'vuex';
import AppHeaderBase from '@/layouts/components/AppHeaderBase';
import HeaderMenu from '@/layouts/components/HeaderMenu';
import AppLoginForm from '@/components/AppLoginForm';

export default {
  name: 'job-request-header',
  components: {
    AppHeaderBase,
    HeaderMenu,
    AppLoginForm,
  },
  computed: {
    ...mapGetters('user', [
      'firstName',
      'isLoggedIn',
      'isPro',
    ]),
    showLightHeader () {
      return !this.isPro;
    },
  },
};
</script>
